<template>
    <!-- 基本燈箱樣式 -->
    <div
        class="modal items-center"
        :class="{'modal-open':visiblePopup}"
    >
        <!-- xs:max-w-[23.375rem] -->
        <div
            class="modal-box p-4 rounded"
            :class="modalWidth"
        >
            <div v-if="visiblePopup">
                <button
                    v-if="closeicon"
                    class="btn btn-circle btn-ghost border-0 absolute right-1 top-1"
                    @click="handleClose"
                >
                    <SvgIcon
                        icon-name="close"
                        class="text-gray-400 w-6 h-6 cursor-pointer"
                    />
                </button>
                <div class="border-b text-base xs:text-lg text-gray-900 font-bold pb-3 border-gray-100">
                    <slot name="title">
                        {{ params.title||'請確認' }}
                    </slot>
                </div>
                <div class="py-5 text-[0.93rem] xs:text-base text-gray-700 border-b border-gray-100">
                    <slot name="content">
                        <div v-html="params.content" />
                    </slot>
                </div>
                <div class="modal-action mt-0 pt-3 flex flex-wrap justify-end">
                    <slot name="action">
                        <!-- <button
                            class="btn btn-accent rounded-full"
                            @click="handleClose"
                        >
                            取消
                        </button> -->
                        <button
                            v-if="params.cancelButton"
                            class="btn btn-accent rounded-full"
                            @click.stop="$emit('cancel')"
                        >
                            {{ params.cancelButton }}
                        </button>
                        <button
                            v-if="params.confirmButton"
                            class="btn rounded-full"
                            :class="[params.isDisabledButton? 'btn-accent' : params.isErrorButton ?'btn-error':'gradient-primary' ]"
                            :disabled="params.isDisabledButton"
                            @click.stop="$emit('confirm')"
                        >
                            {{ params.confirmButton }}
                        </button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { watchEffect, ref, onUnmounted } from 'vue';
import { enableScroll, disableScroll } from '@/utils/style/fixedBodyScroll';

export default {
    props: {
        visiblePopup: {
            type: Boolean,
            default: false,
        },
        closeicon: {
            type: Boolean,
            default: false,
        },
        overlayClose: { // 點擊遮罩關閉
            type: Boolean,
            default: false,
        },
        modalWidth: {
            type: String,
            default: 'max-w-[90%] xs:max-w-[23.375rem]',
        },
        params: {
            type: Object,
            default: () => {
                return {
                    title: '請確認',
                    content: '',
                    confirmButton: '確認', // 不傳不顯示
                    isErrorButton: false, // 確認是紅色按鈕嗎？紅色：藍色
                    isDisabledButton: false,
                    cancelButton: '取消',
                };
            }
        },
    },
    emits: ['update:visiblePopup', 'handleClose', 'confirm', 'cancel'],
    setup(props, { emit }) {
        const visible = ref(false);

        onUnmounted(() => {
            enableScroll();
        });

        watchEffect(() => {
            visible.value = props.visiblePopup;
            visible.value ? disableScroll() : enableScroll();
        });

        const handleClose = () => {
            emit('handleClose');
            // emit('update:visiblePopup', false);
        };

        return {
            visible,
            handleClose,
        };
    }
};

</script>
<style lang="scss" scoped>
:deep(.modal-action) {
    // button {
    //     @apply mr-0.5 ml-0;
    //     &:last-child {
    //         @apply mr-0;
    //     }
    // }
    button {
        @apply ml-0.5 mt-1;
        &:first-child {
            @apply ml-0;
        }
    }
}
.modal {
    z-index: 500;
}
</style>
